import script from "./KpiCard.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiCard.vue?vue&type=script&setup=true&lang=js"

import "./KpiCard.vue?vue&type=style&index=0&id=c99333c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c99333c0"]])

export default __exports__